import React, {useContext, useEffect, useState} from 'react';
import Button from 'antd/lib/button';
import {FormContext} from "../../metadata/MDForm";
import {ModelContext} from "../../metadata/ModelSource";
import {env} from "../../../env";

const creditCardInfoTemplate = {
  type:'',
  expDate:'',
  lastFour:'',
  name: '',
};

export const CreditCardButton = ({ attr, url, title }) => {
  const [error, setError] = useState('');
  const [creditCardInfo, setCreditCardInfo] = useState(creditCardInfoTemplate);

  const applicationModel = useContext(ModelContext);
  let { setValueByAttr,getValueByAttr, getValue } = useContext(FormContext);

  useEffect(()=>{
    const customerPaymentProfileId = getValueByAttr('CustomerPaymentProfileId');
    if (customerPaymentProfileId){
      const {id, name, expDate, type} = JSON.parse(localStorage.getItem('CREDIT_CARD__INFO_KEY'));
      if (_.isEmpty(id) || id !== applicationModel.data.systemId) return;
      const creditCardInfo = {
        type:type,
        expDate:expDate,
        lastFour:getValueByAttr('CreditCardNumber'),
        name:name,
      };
      setCreditCardInfo(creditCardInfo);
    }
  },[])

  const onClickHandler = ()=>{
    const config = {
      'paymentConfigId': env.creditCardPaymentConfigId, //env
      'tenant': env.creditCardPaymentTenant, //env
      'apiUrl': env.creditCardPaymentApiUrl, //env
      'carrierCode': getValue('basicPolicy.carrierCd'),
      'companyId': '',
      'customerId': 'CUST-!M2R7UN2uOI3CJarNLk1tJ8+eQj0=',
      // OPTIONAL: should be omitted unless you need to test a preproduction api (local or staging)
      //  default is 'https://payments.iscs.io/'
      'uiDisplayConfirmation': false,
      'featureCustomAddressCollection': true,

      //UI
      'uiAcceptJsButtonText': 'Save Card',
      'uiAcceptJsHeaderText': 'Card Information',
      'uiAcceptJsBillingAddressOptionsJson': '{"show":false, "required":false}',
      'uiSdkAddressButtonText': 'Continue',
      'uiSdkAddressHeaderText': 'Card Billing Address',
      'uiSdkBackgroundColor': 'rgba(0, 0, 0, 0.1)',
      'uiSdkCloseButtonAriaAndTitle': 'Close',
      'uiSdkCloseButtonStyles': '',
      'uiSdkHideLoader': false,
      'uiSdkLoaderText': 'Loading...',
      'uiSdkLoaderColor': '#434958',
    };

    const sdk = GuidewirePayments.createSDK(config);

    // call `sdk.collectAndAssociateCard(callback)` when the user presses an "add CC" button
    sdk.collectAndAssociateCard(result => {
      switch (result.type) {
        case 'ERROR':
          // handle error, since error message from SDK is not user friendly and there is not error code from SDK,
          // so we use this one as general error message
          handlerError('The credit card information you entered is not valid.');
          break;
        case 'CARD_ADDED':
          // not sure if result.debug is available in product env, if not , use result.card and name will not be showing
          const card = result.debug && result.debug.saveCardRequest ? result.debug.saveCardRequest : result.card;
          const creditCardInfo = {
            type:card.cardType.toLowerCase(),
            expDate:card.expDate.substring(5)+'/'+result.debug.tokenizedCard.expDate.substring(2,4),
            lastFour:card.lastFour,
            name:card.firstName +' ' +  card.lastName,
          };
          setCreditCardInfo(creditCardInfo);
          addCardInfoToLocalStorage(creditCardInfo);
          addPaymentSourceInfoToFormContext(result.card);
          break;
        case 'CANCELED':
          // user canceled
          break;
        case 'CARD_TOKENIZED':
          // only tokenize the card info
          break;
        default:
          console.warn('unexpected response type from payments sdk', result);
      }
    });
  }


  const addCardInfoToLocalStorage = ({expDate, name, type}) => {
    localStorage.setItem('CREDIT_CARD__INFO_KEY', JSON.stringify({id: applicationModel.data.systemId, expDate,name, type}));
  }

  const addPaymentSourceInfoToFormContext = ({id,lastFour})=>{
    setValueByAttr('CustomerPaymentProfileId', id.toString());
    setValueByAttr('CustomerProfileId', id.toString());
    setValueByAttr('CreditCardNumber', `${lastFour}`);
    applicationModel.setValue('basicPolicy.electronicPaymentSource.paymentServiceAccountId',getValue('basicPolicy.carrierCd'))
  };

  const handlerError = (errorMsg)=>{
    setError(errorMsg);
    setCreditCardInfo(creditCardInfoTemplate);

    setValueByAttr('CustomerPaymentProfileId', '');
    setValueByAttr('CustomerProfileId', '');
    setValueByAttr('CreditCardNumber', '');
    setValueByAttr('CreditCardTypeCd', '');
  }

  return (
    <div>
      <Button type="primary" onClick={onClickHandler} style={{marginBottom:'20px'}}>
        {title}
      </Button>
      {creditCardInfo.lastFour && <div>
        <p>Credit Card Details</p>
        <p><strong>{`cc-${creditCardInfo.type}`}</strong> **** **** **** {creditCardInfo.lastFour}</p>
        <p>{creditCardInfo.expDate}</p>
        <p>{creditCardInfo.name}</p>
      </div>}
      {error && <p style={{color:'red'}}>{error}</p>}
    </div>
  );
};
